var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSky(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2049 1152",
    width: 2049,
    height: 1152,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 2056.9,
    y1: -47.7,
    x2: 2065.6,
    y2: 913.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72a1fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1fff1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 150.8,
    y1: 589.7,
    x2: 89.3,
    y2: 336.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0b4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbe6fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 146.5,
    y1: 573.2,
    x2: 107,
    y2: 410.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d9dfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5bdf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 120.2,
    y1: 425.9,
    x2: 101.2,
    y2: 347.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 225.9,
    y1: 422,
    x2: 220.1,
    y2: 398.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 804.6,
    y1: 872.6,
    x2: 689,
    y2: 206.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0b4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbe6fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 1433,
    y1: 582,
    x2: 1426.6,
    y2: 501.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d9dfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5bdf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 1921.2,
    y1: 611.8,
    x2: 1871.6,
    y2: 456.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d9dfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5bdf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 1482.8,
    y1: 317.5,
    x2: 1491.5,
    y2: 172.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 1577.8,
    y1: 444.7,
    x2: 1547.5,
    y2: 254.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 1784.1,
    y1: 452,
    x2: 1785.3,
    y2: 431.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 1771.4,
    y1: 408.1,
    x2: 1773.6,
    y2: 371.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 1350.2,
    y1: 284.6,
    x2: 1354.1,
    y2: 218.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 951.2,
    y1: 325.6,
    x2: 872.4,
    y2: 113,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 742.1,
    y1: 397.8,
    x2: 749.3,
    y2: 277,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 935.8,
    y1: 490.6,
    x2: 925.5,
    y2: 433.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d9dfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5bdf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 750.5,
    y1: 487.3,
    x2: 716.4,
    y2: 380.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d9dfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5bdf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 1155.6,
    y1: 326.6,
    x2: 1101.4,
    y2: 157.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 921.5,
    y1: 834.1,
    x2: 875.9,
    y2: 576.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0b4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbe6fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 962.4,
    y1: 832.8,
    x2: 934.4,
    y2: 747.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d9dfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5bdf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 911.1,
    y1: 544.8,
    x2: 731.1,
    y2: 96.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 1082.1,
    y1: 530.7,
    x2: 1074.6,
    y2: 488,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x1: 296.2,
    y1: 548.6,
    x2: 258.5,
    y2: 285.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0b4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbe6fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x1: 494.2,
    y1: 814.2,
    x2: 159.6,
    y2: 191.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d9dfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5bdf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g25",
    x1: 274.2,
    y1: 340.3,
    x2: 258.5,
    y2: 152.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g26",
    x1: 432.3,
    y1: 374.5,
    x2: 427.7,
    y2: 319.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g27",
    x1: 486.8,
    y1: 385.7,
    x2: 485.5,
    y2: 369.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x1: 606.3,
    y1: 396.7,
    x2: 603.8,
    y2: 366.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x1: 1920.4,
    y1: 486.7,
    x2: 1845.4,
    y2: 194.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0b4fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbe6fd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g30",
    x1: 1952.8,
    y1: 236.8,
    x2: 1937,
    y2: 174.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9e9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4ff"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#g1)}.b{fill:url(#g2)}.c{fill:url(#g3)}.d{fill:url(#g4)}.e{fill:url(#g5)}.f{fill:url(#g6)}.g{fill:url(#g7)}.h{fill:url(#g8)}.i{fill:url(#g9)}.j{fill:url(#g10)}.k{fill:url(#g11)}.l{fill:url(#g12)}.m{fill:url(#g13)}.n{fill:url(#g14)}.o{fill:url(#g15)}.p{fill:url(#g16)}.q{fill:url(#g17)}.r{fill:url(#g18)}.s{fill:url(#g19)}.t{fill:url(#g20)}.u{fill:url(#g21)}.v{fill:url(#g22)}.w{fill:url(#g23)}.x{fill:url(#g24)}.y{fill:url(#g25)}.z{fill:url(#g26)}.A{fill:url(#g27)}.B{fill:url(#g28)}.C{fill:url(#g29)}.D{fill:url(#g30)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m0.7-6.1h2050.5v882.2h-2050.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m376.1 471.3c0 0-2-0.2-5.6-0.5-35.4-3.7-227.6-24.5-250.1-48q-1-1.1-1.6-2.2c0 0-0.1-6 0.3-14.7 1.1-19.5 5.2-52.7 21.1-64.2 17.6-12.7 49-1.8 66.1 12.4 5.4 4.3 9.3 9.1 11 13.5 7.3 18.8 7.5 38.8 7.5 38.8 0 0 10.7-27.2 27.2-13q1 0.9 1.9 1.8 0 0 0 0.1c14.6 15.1 13.8 47.7 15.6 49.5 1.9 2 65.7 4.1 72.6 5.4 6.9 1.4 34 21.1 34 21.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m120.4 422.8l47.5 4.3-3.3-2.9 91.1 19.5-19.6 6c0 0 114.2 18 134.4 21.1-35.4-3.7-227.6-24.5-250.1-48z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m119.1 405.9c1.1-19.5 5.2-52.7 21.1-64.2 17.6-12.7 49-1.8 66.1 12.4q0 0 0 0c17.4 37.4-51 65.4-87.2 51.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m226.9 417.1c5.2 17.7 39.1-13.7 25.1-23.7-14-9.9-28.7 11.1-25.1 23.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m2035.6 550.1l-44.9-4c-133.8-22.2-77.8-16-86.3-25.1q0 0-0.1 0-0.6-0.6-3.4-1.4c-41.3-10.6-423.5-46.1-466.3-65.7-2.5-1.2-3.8-2.3-3.9-3.3-0.7-16.8 31.5-69.8 40.4-84.1 1.4-2.2 2.2-3.5 2.2-3.5 0 0-279.7-34.9-281.8-15.7-2.1 19.2 40.2 45.9 14.5 40.1-162.2-36.6-200.2 17.5-208.3 36.5-1.7 3.8 3 23.5 3 23.5l-125.9 7.3c0 0-118.8-8.4-133.9-17.7-1.5-0.9-2-1.9-1.3-2.8 1-1.1 2.1-4.5 3.4-9.7 10.9-41.6 21.7-148.1 89.1-169.2 37.3-11.6 61.2-2.3 75.9 10.2 6.2 5.2 10.8 11 14 16.1q1.6 2.3 2.8 4.6 0.1 0.2 0.2 0.5c2.5 4.6 3.6 7.8 3.6 7.8 0 0 1.6-8 5-21.2 17.8-67.5 84.5-271.9 238.5-253.3 71.5 8.6 114.3 53 139.9 104.2 40.4 80.6 38.1 177.8 38.1 177.8 0 0 2.6-5.6 7.1-14 14.6-27.7 50.2-86.1 88.1-82.7 16.8 1.5 26.6 16 32.3 34.4v0.1c11.1 36.2 6.3 87.7 6.3 87.7 0 0 2.7-8.1 7.8-20.9l1.1-2.6 0.8-2c21.8-52.8 79.3-168.3 162.5-160.8 32.9 2.9 56.6 29.9 73.7 65.9 38.8 81.9 43.3 210.6 43.3 210.6 0 0 1.8-5 5.4-12.2 11.1-22.2 39.2-65 84-45.3 10.2 4.5 18.4 12 25 21.3 31.5 44.6 27.4 131.5 45 139.9 21.4 10.3 44.6-20.9 60-4.9 15.4 15.9 43.1 33.6 43.1 33.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m1900.9 519.6c-41.3-10.6-423.5-46.1-466.3-65.7l-3.9-3.3 163.1 6.4c0 0-19.6-10.1-19.3-15.6 0.3-5.5 322.7 4.1 275.4 47-6.9 6.2 38.3 26.3 51 31.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m2035.6 550.1l-44.9-4c-133.8-22.2-77.8-16-86.3-25.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m1729.8 207.1q0 0-0.1 0.1c-6.1 92-94.3 132.5-228 120.5l-10.6-19.5 0.6-1.6 1.1-2.6 0.8-2c21.8-52.8 79.3-168.3 162.5-160.8 32.9 2.9 56.6 29.9 73.7 65.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m1582.9 433.5c0 0 63.1-85.4 123.3-66.1 60.2 19.2 58.7 55.1 58.7 55.1 0 0-41 26.1-182 11z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m1790.5 446.3c0 0 8.9-17.9 23.7-19.4 14.7-1.4 29.7 30.1 29.7 30.1 0 0-56 3.6-53.4-10.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m1887.5 381.5c-6.1 12.2-15.7 24.2-30.8 31.1-38.7 17.6-78.2-7.1-78.2-7.1 11.1-22.2 39.2-65 84-45.3 10.2 4.5 18.4 12 25 21.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m1357.2 288c14.6-27.7 50.2-86.1 88.1-82.7 16.8 1.5 26.6 16 32.3 34.4v0.1c2.1 40.1-56.4 52-120.4 48.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m1155.6 193.6c0 0-10.9 51.1-41.5 72.5-30.6 21.3-155.2 32.5-180.5 7.2 17.8-67.5 84.5-271.9 238.5-253.3 71.5 8.6 114.3 53 139.9 104.2 6.8 79.7-156.4 69.4-156.4 69.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m902.7 356.3c-2.6 3.1-20.5-1.8-20.5-1.8 0 0 18.2-3.5-26.3 41.9-44.5 45.4-106.6 11.3-106.6 11.3 10-37.7 19-134.4 81.5-153.3 34.6-10.5 56.8-2 70.5 9.4 5.3 5 9.8 9.9 13 14.6q1.4 2.1 2.5 4.2 0.1 0.2 0.2 0.4c18.6 36.2-11.7 70.2-14.3 73.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m1471.1 366.5c1.4-2.2 2.2-3.5 2.2-3.5 0 0-282.3-35.1-281.8-15.7 0.2 7.3 14.7 24.9 37.8 39.9 21.7 14 75.7 21.2-231.6 36.7 0 0-71.6-24.3-70.6-40.9 1-16.5 77.1-12.4 77.1-12.4 0 0 190.5-20.3 176.5-25.7-134.3-51.8 173.7-2.8 173.7-2.8 0 0 83.5-27.5 107.6-16.5 24.1 10.8 60.6 41.8 60.6 41.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m739.6 434.2c-11.6-8.9 261.1 13.2 261.1 13.2 0 0-180.8 48.2-261.1-13.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m1153.1 310.5c0 0 4.8-90.2 60.5-89.4 55.7 0.9 60 52.9 60 52.9 0 0-5.9 42.6-120.5 36.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m1085.4 536.1c0 0 3.4 39.8-2.6 43.4-6 3.6-199.8-25.6-199.8-25.6l8.2-47 5.9-33.5c0 0 17.8-81.5 92.3-76.9 42.2 2.7 67.9 37 82.4 66.4 11 22.6 15.4 42.2 15.4 42.2 0 0 0.3-0.6 0.7-1.7q0 0 0-0.1c0.6-1.2 1.4-3 2.5-5.1q0.2-0.2 0.2-0.2c5-9.3 15.9-23.3 32.2-14.6 8.6 4.5 13.8 12.4 17 20.6q0 0 0 0c5.5 14.2 4.9 29.1 4.9 29.1 0 0 61.4-17.1 69.3-8.1 7.9 9.1 91.2 39.5 91.2 39.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m885 557.8c-10.1-21.6 48.9-27.5 93.9-23.4 45.1 4 107.4 28.2 107.4 28.2l-1.5-31.2 59.7 12.3c0 0 43.1-5.8 63 2.5 19.9 8.2 97.6 18.3 97.6 18.3 0 0-84.4-7.4-108.3-9.1-23.9-1.7-111.2-7.3-111.2-7.3 0 0 6.4 32.5 2 37.6-4.4 5.2-196.2-14.4-202.6-27.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m1071.8 462.9c0.4 20-27.1 3.3-27.1 3.3 0 0-2.5 30.9-82.3 46.6-38.6 7.5-59.7 1.9-71.2-5.9l5.9-33.5c0 0 17.8-81.5 92.3-76.9 42.2 2.7 67.9 37 82.4 66.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m1108.1 524.5c-23.2-2.1-22.7-14-20.2-21.1q0 0 0-0.1c0.9-2.5 2.1-4.5 2.5-5.1q0.2-0.2 0.2-0.2c5-9.3 15.9-23.3 32.2-14.6 8.6 4.5 13.8 12.4 17 20.6q0 0 0 0c0.1 1.1 1.2 23.5-31.7 20.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m802 445.9q-0.1 0-0.2 0-0.1 0-0.2 0c-5 0.7-64.5 7.5-156.8-6.6-95.5-14.6-160-33.5-161.4-33.9 0.3 1.2 9.2 33.1-8.9 38.6-16.1 5-160 9.2-189.4-46.2-4-7.7-5.9-16.5-4.9-26.6 0 0 0-4.1 0.3-10.8 1-27.2 5.6-98.1 26.1-117.4 21.2-20 118.7-38.4 159.3 0.3 8.1 7.8 14 17.9 16.4 30.7 14.8 76.7 4.6 104.1 4.6 104.1 0 0 14.6-18.5 27.2-12.2 12.5 6.2 10.7 36.4 10.7 36.4 0 0 63.1 21.2 82.4-1.4 19.3-22.5 25.7-37.1 51.6-35 25.9 2.2 52.1 63.6 52.1 63.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m801.6 445.9c-5 0.7-64.5 7.5-156.8-6.6-95.5-14.6-160-33.5-161.4-33.9 0.3 1.2 9.2 33.1-8.9 38.6-16.1 5-160 9.2-189.4-46.2l163 3.1-15.4-13.5 135.5 32.8c0 0 71-6.5 95.4 3 24.2 9.4 124.6 23.9 138 22.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m431 362.6c-21.5 21.9-104.7 17.7-132.5 11.3-8.6-2-14.3-7.2-18-13.5 1-27.2 5.6-98.1 26.1-117.4 21.2-20 118.7-38.4 159.3 0.3 25.8 44-13.3 97.4-34.9 119.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m472.7 342.1c13.8 1.2 20.6 29.5 10.3 43.8-10.4 14.4-44.8-5.6-44.8-5.6 0 0 20.7-39.5 34.5-38.2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m497.9 387.8c10.6 1.4 23.3-8.2 16.4-15.7-7-7.4-37.7 13-16.4 15.7z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m612.8 399.3c1.6-12 38-41.5 52.5-24.4 14.5 17.2-18.5 34.7-45.6 28.5 0 0-8.4 7.8-6.9-4.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m2035.6 281.1c0 0-8.3 10.6-33 7.6-67.3-8.3-55.4-20.1-55.4-20.1 0 0-73.8 1.4-75.4-7.3-1.6-8.7 47.9-34.8 62.8-27 14.9 7.7 14.9 22.7 14.9 22.7 0 0 1.5-9.9 4.8-23.3 7.4-30.2 23.9-78.6 53.7-75.2 5.6 0.6 10.2 3.1 14 7q2.9 3.1 5.2 7.2c0.1 0 0.1 0 0.1 0.1q1.9 3.4 3.5 7.4 0 0.1 0 0.1c13.5 35.3 4.8 100.8 4.8 100.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m1961.7 246c-3.3-2.8-5.7-7.1-7.4-12.3 7.4-30.2 23.9-78.6 53.7-75.2 5.6 0.6 10.2 3.1 14 7q2.4 3.5 5.2 7.2c0.1 0 0.1 0 0.1 0.1 1.5 1.9 2.7 4.5 3.5 7.4q0 0.1 0 0.1c8.5 30.9-19.5 107.3-69.1 65.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSky);
export default __webpack_public_path__ + "static/media/sky.c1062f25d271abc82935e2e018d30732.svg";
export { ForwardRef as ReactComponent };